// extracted by mini-css-extract-plugin
module.exports = {"title":"FormTestComponent__title--3wn","swEmpireIcon":"FormTestComponent__swEmpireIcon--lkg"};